<div class="d-flex flex-row align-items-center stats-item">
  <img src="{{ icon }}" alt="{{title}} icon" />
  <p class="stats-count">{{ value }}</p>
  <p class="stats-title">{{ title }}</p>
</div>
